import { Trans } from 'react-i18next';

import { Alert, Anchor } from '@myphx-engineering/phx-design-system';
import { TalkativeWidget } from '@phx/talkative';

export interface MaxRecoveryVerificationAttemptsReachedErrorProps {
    onLinkClick: () => void;
    onContactUsClick: () => void;
}

export const MaxRecoveryVerificationAttemptsReachedError = (
    props: MaxRecoveryVerificationAttemptsReachedErrorProps
) => {
    const { onLinkClick, onContactUsClick } = props;

    return (
        <Alert
            data-testid="max-recovery-attempts-reached-error"
            severity="error"
        >
            <Trans i18nKey="formErrors.maxRecoveryVerificationAttemptsError">
                Incorrect code. Please{' '}
                <Anchor onClick={onLinkClick}>try again</Anchor> or{' '}
                <TalkativeWidget onClick={onContactUsClick} />.
            </Trans>
        </Alert>
    );
};
